import React from 'react'

export class Contact extends React.Component {
    render(){
        return(
            <section className="section" id="page-content">Contact Page</section>
        );
    }
}